
























































































































































import $ from 'jquery';
import { RanchVariableData, RanchVariablesCategorized } from '../../../../features/insurance/api/harvestModels';
import { Component, Mixins, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { AuthStoreHelper, RootStoreHelper, NotificationStoreHelper, VehicleStoreHelper } from '../../../core/mixins';
import { InsuranceServices } from '../../../../features/insurance/api/InsuranceServices';
import { ColorsList, getValueWithCustomDecimals, milisecondsToTimestamp, parseFloatNumber, timestampToTime } from '../../../../features/core/utils';
import { Chart } from 'highcharts-vue';
import InfoIcon from '../../../core/components/InfoIcon.vue';
import Highcharts, { chart } from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import moment from 'moment';
import { dateTypes } from '../../../../features/core/models/date-models';
exportingInit(Highcharts);
import loading from 'vue-loading-overlay';
import { unitsValuesChoices, unitValues } from '../../../../features/core/api/ValuesHelper';
import { nullOrEmptyFormatter } from '../../../core/utils';
import LoadingIndicator from '../../../../features/core/components/LoadingIndicator.vue'
import Axios, { CancelTokenSource } from 'axios';
const context = this;
@Component({
    components: {
        highcharts: Chart,
        loading,
        InfoIcon,
        LoadingIndicator
    }
})

export default class RanchVariablesChart extends Mixins(NotificationStoreHelper, RootStoreHelper, VehicleStoreHelper, AuthStoreHelper) {
    @Prop({default: null}) ranchId: number;
    @Prop({default(){return []}}) satelliteImages: Array<object>;
    @Prop({default: ''}) currentTimestamp: object;
    @Prop({default: 0}) currentImageIndex: number;
    @Prop({ default: '' }) harvestStartDate: string;
    @Prop({ default: '' }) bandSelected: string;
    @Prop({ default: null }) mostRepresentativeImage: object | null;
    collapsiblePanel: number | null = 0;
    activesVariables: string[] = [];
    variables: Array<RanchVariableData> | [] = [];
    categorizedVariables: RanchVariablesCategorized | null = null;
    tooltipMsgAdd = 'Añadir variable a gráfica actual';
    tooltipMsgRemove = 'Quitar variable de la gráfica actual';
    gettingVariables: boolean = false;
    colorMin: string = ColorsList.purple;
    colorMax: string = ColorsList.orange;
    colorMedian: string = ColorsList.skyblue;
    minTemp: number | null = null; 
    maxTemp: number | null = null; 
    avgTemp: number | null = null; 
    sumRain: number | null = null;
    maxTempDays: number | null = null; 
    unitTemp: string = unitValues[unitsValuesChoices.temperature];
    unitRain: string = unitValues[unitsValuesChoices.rain];
    requestTokenInstance: CancelTokenSource = Axios.CancelToken.source();
    isLoaded: boolean = false;
    chartOptions: object = {
        events: {
            load: function(){
                $(window).trigger('resize')
            },
        },
        tooltip: {
            
            formatter: function() {
                let seriesName = this.series.name;
                let serieCategory = this.series.userOptions.category;
                return `
                    <b>Variable: ${seriesName}</b><br>
                    <b>Fecha:</b> ${moment(this.x).format('DD/MM/YYYY')}<br>
                    <b>Valor:</b> 
                        ${getValueWithCustomDecimals(this.point.y)} 
                        ${serieCategory !== 'satellital' ? unitValues[unitsValuesChoices[serieCategory]] :  ''}
                `
            }
        },
        legend: { enabled: true },
        chart: {
            zoomType: 'x'
        },
        title: {
            text: ''
        },
        yAxis: [
            {
                opposite: false,
                showLastLabel: true,
                alignTicks: false,
                title: {
                    text: ''
                }
            },
            {
                opposite: true,
                alignTicks: false,
                showLastLabel: true,
                title: {
                    text: ''
                }
            }
        ],
        time: {
            useUTC: false
        },
        xAxis: {
            ordinal: false,
            minPadding: 0,
            maxPadding: 0,
            title: {
                text: 'Fecha'
            },
            type: 'datetime',
            labels: {
                format: '{value:%e/%m/%y}'
            },
            events: {
                setExtremes: event => {
                    // console.log("event", event);
                    let minDate = '';
                    let maxDate = '';
                    if (event && !event.min && !event.max) {
                        minDate = '';
                        maxDate = '';
                    }else{
                        minDate = milisecondsToTimestamp(new Date(event.min));
                        maxDate = milisecondsToTimestamp(new Date(event.max));
                    }
                    this.updateStats(minDate, maxDate)
                }
            },
        },
        plotOptions: {
            series: {
                cursor: 'pointer',
                point: {
                    events: {
                        click: (event) => {
                            if(event.point.series.userOptions.category === 'satellital'){
                                this.clickChartPoint(event.point.index);
                            }
                        }
                    }
                }
            }
        },
        series: [],
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: [
                        'downloadPNG',
                        'downloadJPEG',
                        'downloadPDF',
                    ]
                }
            }
        }
    };
    chartReferences: Array<object> = [];
    satelliteReferences: Array<object> = [
        {
            color: ColorsList.green,
            value: 'Imagen Actual'
        },
        {
            color: ColorsList.red,
            value: 'Inicio Cosecha'
        },
        {
            color: ColorsList.navy_blue,
            value: 'Imagen Representativa'
        },
        
    ];
    baseReferences: Array<object> = [
        {
            color: this.colorMedian,
            value: 'Mediana'
        },
        {
            color: this.colorMin,
            value: 'Mínimo'
        },
        {
            color: this.colorMax,
            value: 'Máximo'
        }
    ];
    categoriesLabel: object = {
        humidity: 'Humedad',
        temperature: 'Temperatura',
        rain: 'Lluvia',
        satellital: 'Satelital'
    }

    categoriesInfo: object = {
        humidity: 'Humedad relativa del aire (%)',
        temperature: '',
        rain: '',
        satellital: ''
    }

    minMaxMeanColor: object = {
        min: ColorsList.purple,
        max: ColorsList.orange,
        mean: ColorsList.skyblue,
    }

    categoriesColors: object = {
        humidity: this.minMaxMeanColor,
        temperature: this.minMaxMeanColor,
        rain: this.minMaxMeanColor,
        satellital: this.minMaxMeanColor
    }
    satellitalMinPoint: number = 0;
    satellitalMaxPoint: number = 1;
    datetimeFrom: string = '';
    datetimeTo: string = '';
    loadingStats: boolean = false;

    get showSatelliteImagesLayer(){
        return this.satelliteImages.length > 0;
    }

    updateStats(datetime_from, datetime_to){
        // console.log("pido stats", {
        //     ranch: this.ranchId,
        //     desde: datetime_from,
        //     hasta: datetime_to
        // })

        this.requestTokenInstance.cancel();
        this.requestTokenInstance = Axios.CancelToken.source();

      
        this.loadingStats = true;

        InsuranceServices.getSatellitalImagesStatsByRanch(
            this.ranchId,
            this.requestTokenInstance,
            datetime_from,
            datetime_to,
        ).then((res) => {
            this.minTemp = parseFloatNumber(res.temperature_min);
            this.maxTemp = parseFloatNumber(res.temperature_max);
            this.avgTemp = parseFloatNumber(res.temperature_avg);
            this.sumRain = parseFloatNumber(res.rain_sum);
            this.maxTempDays = res.max_temperature_days;
        }).catch((err) => {
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'No se pudieron obtener las estadisticas'
            });
        }).finally(() => {
            this.loadingStats = false;  
        })
    }

    valueFormatter(value){
        return nullOrEmptyFormatter(value)
    }

    @Watch('currentImageIndex', { immediate: true })
    onIndexChange(){
        this.updateCurrentTimestampImage()
    }

    @Watch('activesVariables', { immediate: true })
    onActivesVariablesChange(){
        this.updateChartReferences();
    }

    @Watch('bandSelected', { immediate: true })
    onBandChanged(){
        this.bandChangedEvent();
    }

    bandChangedEvent(){
        //evento que se dispara cuando cambia el tipo de banda
        //si la variable satelital esta activa la quito
        if(this.variableIsActive('satellital')){
            this.removeVariableFromChart('satellital');
        }
        //actualizo los datos satelitales del grafico
        this.addVariableToChart('satellital');
    }


    updateChartReferences(){
        //si la variable satelital esta activa, agrego las referencias de satelital
        //si no, las quito
        if(this.variableIsActive('satellital')){
            this.chartReferences = [
                ...this.baseReferences,
                ...this.satelliteReferences
            ]
        }else{
            this.chartReferences = this.baseReferences;
        }
    }

    updateCurrentTimestampImage(){
        //al cambiar el indice de la imagen actual actualizo la linea vertical del grafico
        if(this.variableIsActive('satellital')){
            this.removeVariableFromChart('satellital');
            this.addVariableToChart('satellital');
        }
    }



    async getVariables(){
        this.gettingVariables = true;
        InsuranceServices.getSatellitalImagesListValues(
            this.ranchId
        ).then((res: RanchVariablesCategorized) => {
            res['satellital'] = this.getSatellitalLayerData();
            this.updateStats('', '');
            this.categorizedVariables = res;
            this.preselectSatellitalVariable();
        }).catch((err) => {
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'No se pudieron obtener las variables'
            });
        }).finally(() => {
            this.gettingVariables = false;
        })
    }

    getSatellitalLayerData(){
        //agrego a la respuesta del WS que devuelve las variables, la capa de imagenes satelitales
        //que viene de otro WS performance/ranch/satellital/images/
        let satellitalLayerData = this.satelliteImages.map((item) => {
            return {
                date: item['date'],
                value: item['value'],
                band: item['band'],
            }
        })
        return satellitalLayerData
    }

    removeVariableFromChart(category:string) {
        //quito la variable de la lista de activas
        try{
        
            this.activesVariables = this.activesVariables.filter((item) => {
                return item !== category;
            })

            //quito las plotLines del grafico si no hay variables satelitales activas
            if(!this.variableIsActive('satellital')){
                this.assignPlotLines([]);
            }


            //quito la variable de la lista de series
            let filteredSeries = this.chartOptions['series'].filter((item) => {
                return item['category'] !== category;
            })

            this.$set(this.chartOptions, 'series', filteredSeries);

        }catch(e){
            // console.log("error al quitar una variable", e);
        }
    }

    toggleVariable(category:string) {
        /* 
            si la variable esta activa, la quito
            si la variable no esta activa, la agrego
        */
        if(this.variableIsActive(category)){
            this.removeVariableFromChart(category);
        }else{
            this.addVariableToChart(category);
        }
        this.redrawChart();

        
    }

    redrawChart(){
        //redibujo el grafico
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'))
        }, 500);
    }

    get variableIsActive(){
        return (variable: string) => {
            return this.activesVariables.includes(variable);
        }
    }

    currentIndexTimestamp(){
        let currentSatelliteImages = this.getCurrentSatelliteImagesByBand();
        let currentImage = currentSatelliteImages[this.currentImageIndex];
        let date = moment(currentImage['date'], dateTypes.dateYearFormatReverse).toDate();
        //calculo el minimo y maximo de la variable satelital
        this.satellitalMinPoint = this.getMinMeanSatellitalPoint(currentSatelliteImages);
        this.satellitalMaxPoint = this.getMaxMeanSatellitalPoint(currentSatelliteImages);
        return date.valueOf()
    }

    getMinMeanSatellitalPoint(images){
        return images.map((item) => {
                return item['value']['mean'];
            }).sort((a, b) => {
                return a - b;
            })[0];
    }

    getMaxMeanSatellitalPoint(images){
        return images.map((item) => {
                return item['value']['mean'];
            }).sort((a, b) => {
                return b - a;
            })[0];
    }

    getCurrentSatelliteImagesByBand(){
        //devuelve las imagenes satelitales filtradas por tipo de banda
        let images = this.satelliteImages.filter((item) => {
            return item['band'] === this.bandSelected;
        })
        return images;
    }

    harvestDateParsed(){
        let harvestDate: any = moment(this.harvestStartDate, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD');
        harvestDate = new Date(harvestDate);
        return harvestDate.valueOf();
    }


    addVariableToChart(category:string){
        /* Agrego grafica nueva */

        //me fijo si la variable tiene datos
        let variableData = this.categorizedVariables && this.categorizedVariables[category] || [];

        let variableHasData = variableData.length > 0;
        if(!variableHasData){
            if(this.isLoaded){
                this.$_showEmptyHistoricalData(`No hay datos para ${category}`)
            }
            return;
        }
        
        //si la variable tiene datos
        //agrego la variable a la lista de activas
        if(!this.variableIsActive(category)){
            this.activesVariables.push(category);
        }
        

        //me quedo con el tipo de grafico que corresponde a la categoria
        let seriesType = this.getChartTypeByCategory(category);

        let currentTimestamp = this.currentIndexTimestamp();
        let plotLinesData = [
            //linea vertical de inicio de la cosecha
            {
                color: ColorsList.red, // Red
                width: 2,
                value: this.harvestDateParsed(),
            },
            //linea vertical imagen actual
            {
                color: ColorsList.green,
                width: 2,
                value: currentTimestamp,
            },
            {
                ...(
                    this.mostRepresentativeImage !== null ? {
                        color: ColorsList.navy_blue,
                        width: 2,
                        value: moment(this.mostRepresentativeImage['date'], dateTypes.dateYearFormatReverse).toDate().valueOf()
                    } : {}),
            }
        ];

        this.chartOptions['yAxis'][1]['title']['text'] = '';

        let points: Array<{
            x: number;
            yMin: number;
            yMax: number;
            yMean: number;
        }> = [];

        //convierto los datos a puntos para el grafico

         //si la variable es categoría satelital, filtro los puntos por tipo de banda
         if(this.variableIsActive('satellital')){
             
            if(category === 'satellital'){
                //filtro los puntos por tipo de banda
                variableData = variableData.filter((item) => {
                    return item['band'] === this.bandSelected;
                })
            }

            // console.log("puntos filtrados por banda", variableData);

            //agrego yAxis title con tipo de banda
            this.chartOptions['yAxis'][1]['title']['text'] = this.bandSelected;
            this.chartOptions['yAxis'][1]['min'] = this.satellitalMinPoint || 0
            this.chartOptions['yAxis'][1]['max'] = this.satellitalMaxPoint || 1
         }
         
        points = variableData.map((item: RanchVariableData) => {
            let timestampAsDate = timestampToTime(item.date)
            let point = {
                x: timestampAsDate,
                yMin: item.value.min || null,
                yMax: item.value.max || null,
                yMean: item.value.mean,
            }
            return point
        })


        //las series de satelital van en el eje Y 1
        let serieYAxis = 0;
        if(category === 'satellital'){
            serieYAxis = 1;
        }

        //armo las series para el grafico
        let serieName = this.categoriesLabel[category];
        if(category === 'humidity'){
            //si la categoria es humedad, appendeo la aclaracion de humedad
            serieName = this.categoriesInfo[category]
        }

        let meanPoints = points.map(function(point) { return [point.x, point.yMean] }).sort() || [];
        let minPoints = points.map(function(point) { return [point.x, point.yMin] }).sort() || [];
        let maxPoints = points.map(function(point) { return [point.x, point.yMax] }).sort() || [];
        
        let medianSerie = {
            name: `${serieName} (Mediana)`,
            color: this.categoriesColors[category].mean,
            data: meanPoints,
            type: seriesType,
            yAxis: serieYAxis,
            category: category
        };
        let newSeries = [
            {
                name: `${serieName} (Mín)`,
                color: this.categoriesColors[category].min,
                data: minPoints,
                type: seriesType,
                yAxis: serieYAxis,
                category: category
            },
            {
                name: `${serieName} (Max)`,
                color: this.categoriesColors[category].max,
                data: maxPoints,
                type: seriesType,
                yAxis: serieYAxis,
                category: category
            },
            medianSerie
        ]

        if(category === 'satellital'){
            //para la variable satelital solo agrego la serie de la mediana
            newSeries = [medianSerie]
        }

        //asigno plotLinesData en el grafico solo si la variable es satelital esta activa
        if(this.variableIsActive('satellital')){
            this.assignPlotLines(plotLinesData);
        }else{
            this.assignPlotLines([]);
        }

        //agrego las series al grafico
        this.chartOptions['series'] = [
            ...this.chartOptions['series'],
            ...newSeries
        ]
    }

    assignPlotLines(data:Array<object>){
        this.chartOptions['xAxis']['plotLines'] = data
    }

    mounted(){
        this.$nextTick(async () => {
            await this.getVariables();
            this.isLoaded = true;
        })
    }

    preselectSatellitalVariable(){
        this.toggleVariable('satellital');
    }


    getChartTypeByCategory(category:string){
        let types = {
            humidity: 'line',
            temperature: 'line',
            rain: 'column',
            satellital: 'line'
        }
        return types[category];
    }

    clickChartPoint(pointIndex: number){
        this.$emit('update-image-index', pointIndex);
    }
}
